/**
 * assets/product-tabs.js
 * Gedrag van sections/product-tabs.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('[data-product-tabs]');
    if (!section) return;

    /* ─── Een keer renderen (16-10-2026) ───*/
    /* Omschrijving, Toepassing en Specificaties staan alleen in de mobiele accordeon (data-pt-body).
       Vanaf 768px verplaatsen we ze naar de lege desktop-tabpanelen (data-pt-slot), daaronder terug.
       Pas daarna zetten we data-pt-ready: tot dat moment toont de CSS in de sectie de accordeon. */
    const ptMq = window.matchMedia('(min-width: 768px)');
    function ptPlace() {
      const desktop = ptMq.matches;
      section.querySelectorAll('[data-pt-body]').forEach(body => {
        const key = body.dataset.ptBody;
        const target = desktop
          ? section.querySelector(`[data-pt-slot="${key}"]`)
          : section.querySelector(`[data-pt-home="${key}"]`);
        if (target && body.parentNode !== target) target.appendChild(body);
      });
    }
    ptPlace();
    section.setAttribute('data-pt-ready', '');
    if (ptMq.addEventListener) ptMq.addEventListener('change', ptPlace);
    else if (ptMq.addListener) ptMq.addListener(ptPlace);

    /* ─── Content Card Enhancer ───*/
    /* Classifies blockquotes by content pattern (Baymard "feature highlight" approach)*/
    /* Supports both direct HTML (description) and metafield_tag wrappers (toepassing)*/
    function enhanceProseContent(container) {
      if (!container) return;
      /* Unwrap metafield wrapper div so h3 cards work on toepassing tab too*/
      const mfWrapper = container.querySelector(':scope > .metafield-rich_text_field');
      if (mfWrapper) {
        while (mfWrapper.firstChild) container.insertBefore(mfWrapper.firstChild, mfWrapper);
        mfWrapper.remove();
      }
      container.querySelectorAll('blockquote').forEach(bq => {
        const text = bq.textContent || '';
        const strongs = bq.querySelectorAll('strong');

        /* Pattern 1: Q&A block (contains "Vraag:" or "Antwoord:")*/
        if (/\b(Vraag|Antwoord)\s*:/i.test(text)) {
          bq.classList.add('prose-qa');
          return;
        }

        /* Pattern 2: Spec-card (has multiple bold labels like "Merk:", "Inhoud:")*/
        const labelCount = Array.from(strongs).filter(s =>
          /^[A-Za-zÀ-ÿ\s]+:/.test(s.textContent.trim())
        ).length;
        if (labelCount >= 2) {
          /* Already styled as spec-card by default (slate bg), no class needed*/
          return;
        }

        /* Pattern 3: General callout (no structured labels → warm-orange tip/summary)*/
        if (strongs.length === 0 || labelCount === 0) {
          bq.classList.add('prose-callout');
        }
      });

      /* Wrap h3 sections in cards for Gestalt proximity grouping*/
      const h3s = container.querySelectorAll(':scope > h3');
      h3s.forEach(h3 => {
        /* Collect siblings until next h2, h3, or end*/
        const siblings = [];
        let next = h3.nextElementSibling;
        while (next && !['H2', 'H3'].includes(next.tagName)) {
          siblings.push(next);
          next = next.nextElementSibling;
        }
        /* Only wrap if there's content after the h3*/
        if (siblings.length > 0) {
          const card = document.createElement('div');
          card.className = 'prose-section-card';
          h3.parentNode.insertBefore(card, h3);
          card.appendChild(h3);
          siblings.forEach(s => card.appendChild(s));
        }
      });

      /* Alternate section-card backgrounds for visual rhythm (3-color cycle)*/
      const sectionVariants = ['', 'prose-section-card--alt', 'prose-section-card--green'];
      container.querySelectorAll('.prose-section-card').forEach((card, i) => {
        const variant = sectionVariants[i % sectionVariants.length];
        if (variant) card.classList.add(variant);
      });

      /* Wrap standalone lists in highlight cards (Baymard: semantic grouping)*/
      const listVariants = ['', 'prose-list-card--green'];
      let listIdx = 0;
      container.querySelectorAll('ul, ol').forEach(list => {
        if (!list.closest('.prose-section-card') && !list.closest('blockquote') && !list.closest('.prose-list-card')) {
          const card = document.createElement('div');
          card.className = 'prose-list-card';
          const variant = listVariants[listIdx % listVariants.length];
          if (variant) card.classList.add(variant);
          listIdx++;
          list.parentNode.insertBefore(card, list);
          card.appendChild(list);
        }
      });
    }

    /* Apply to all prose containers*/
    section.querySelectorAll('.prose').forEach(enhanceProseContent);

    /* ─── Desktop tab switching ───*/
    const tabs = section.querySelectorAll('[data-product-tab]');
    const panels = section.querySelectorAll('[data-product-panel]');

    /* Helper: activate lazy PDF iframes inside a container*/
    function activateLazyPdfs(container) {
      if (!container) return;
      container.querySelectorAll('iframe[data-lazy-pdf][data-src]').forEach(iframe => {
        if (!iframe.src || iframe.src === 'about:blank') {
          iframe.src = iframe.dataset.src;
          iframe.removeAttribute('data-src');
        }
      });
    }

    function activateTab(tab) {
      const target = tab.dataset.productTab;
      tabs.forEach(t => {
        t.classList.remove('product-tab--active');
        t.setAttribute('aria-selected', 'false');
        t.tabIndex = -1;
      });
      panels.forEach(p => p.classList.add('hidden'));
      tab.classList.add('product-tab--active');
      tab.setAttribute('aria-selected', 'true');
      tab.tabIndex = 0;
      const panel = section.querySelector(`[data-product-panel="${target}"]`);
      if (panel) {
        panel.classList.remove('hidden');
        /* Lazy-load PDFs on first tab activation*/
        activateLazyPdfs(panel);
      }
    }

    const prefersReducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;

    tabs.forEach(tab => {
      const target = tab.dataset.productTab;
      const panel = section.querySelector(`[data-product-panel="${target}"]`);
      tab.id = `product-tab-${target}`;
      tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
      if (panel) panel.setAttribute('aria-labelledby', tab.id);

      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', event => {
        const currentTabs = Array.from(section.querySelectorAll('[data-product-tab]'));
        const index = currentTabs.indexOf(tab);
        if (index < 0) return;
        let nextIndex = null;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % currentTabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + currentTabs.length) % currentTabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = currentTabs.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        const nextTab = currentTabs[nextIndex];
        nextTab.focus();
        nextTab.click();
        nextTab.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      });
    });

    /* ─── Parts list JSON rendering ───*/
    function renderPartsList(container, rawJson) {
      if (!container || !rawJson) return;
      let parts;
      try { parts = typeof rawJson === 'string' ? JSON.parse(rawJson) : rawJson; } catch { return; }
      if (!Array.isArray(parts) || parts.length === 0) return;

      const table = document.createElement('table');
      table.style.cssText = 'width:100%;border-collapse:collapse;font-size:0.8125rem';
      const thead = document.createElement('thead');
      thead.innerHTML = '<tr style="background:#f8fafc"><th style="padding:10px 14px;text-align:left;font-weight:600;color:#1e293b;border-bottom:2px solid #e2e8f0">Nr.</th><th style="padding:10px 14px;text-align:left;font-weight:600;color:#1e293b;border-bottom:2px solid #e2e8f0">Onderdeel</th><th style="padding:10px 14px;text-align:left;font-weight:600;color:#1e293b;border-bottom:2px solid #e2e8f0">SKU</th></tr>';
      table.appendChild(thead);
      const tbody = document.createElement('tbody');
      parts.forEach((part, i) => {
        const tr = document.createElement('tr');
        tr.style.cssText = i % 2 === 0 ? 'background:white' : 'background:#f8fafc';
        tr.onmouseenter = () => tr.style.background = '#eff6ff';
        tr.onmouseleave = () => tr.style.background = i % 2 === 0 ? 'white' : '#f8fafc';
        const tdNr = document.createElement('td');
        tdNr.style.cssText = 'padding:8px 14px;border-bottom:1px solid #f1f5f9;color:#64748b;font-weight:500';
        tdNr.textContent = part.nr || part.nummer || (i + 1);
        const tdName = document.createElement('td');
        tdName.style.cssText = 'padding:8px 14px;border-bottom:1px solid #f1f5f9;color:#1e293b;font-weight:500';
        if (part.url) {
          const a = document.createElement('a');
          a.href = part.url;
          a.textContent = part.name || part.naam || part.title || '-';
          a.style.cssText = 'color:#0ea5e9;text-decoration:none;font-weight:600';
          a.onmouseenter = () => { a.style.textDecoration = 'underline'; };
          a.onmouseleave = () => { a.style.textDecoration = 'none'; };
          tdName.appendChild(a);
        } else {
          tdName.textContent = part.name || part.naam || part.title || '-';
        }
        const tdSku = document.createElement('td');
        tdSku.style.cssText = 'padding:8px 14px;border-bottom:1px solid #f1f5f9;color:#94a3b8;font-size:0.75rem;font-family:monospace';
        tdSku.textContent = part.sku || part.artikelnummer || part.article || '';
        tr.appendChild(tdNr);
        tr.appendChild(tdName);
        tr.appendChild(tdSku);
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      container.appendChild(table);
    }

    /* Render parts list in desktop and mobile containers*/
    const partsRaw = section.querySelector('[data-parts-json]')?.textContent;
    renderPartsList(section.querySelector('[data-parts-list-scroll]'), partsRaw);
    renderPartsList(section.querySelector('[data-parts-list-scroll-mobile]'), partsRaw);

    /* Fits-devices list (reverse of parts list): shows which devices this lamp fits*/
    function renderFitsList(container, rawJson) {
      if (!container || !rawJson) return;
      let items;
      try { items = typeof rawJson === 'string' ? JSON.parse(rawJson) : rawJson; } catch { return; }
      if (!Array.isArray(items) || items.length === 0) return;

      const table = document.createElement('table');
      table.style.cssText = 'width:100%;border-collapse:collapse;font-size:0.8125rem';
      const thead = document.createElement('thead');
      thead.innerHTML = '<tr style="background:#f8fafc"><th style="padding:10px 14px;text-align:left;font-weight:600;color:#1e293b;border-bottom:2px solid #e2e8f0">Nr.</th><th style="padding:10px 14px;text-align:left;font-weight:600;color:#1e293b;border-bottom:2px solid #e2e8f0">Apparaat</th><th style="padding:10px 14px;text-align:left;font-weight:600;color:#1e293b;border-bottom:2px solid #e2e8f0">SKU</th></tr>';
      table.appendChild(thead);
      const rows = items.filter(it => it && typeof it === 'object' && (it.name || it.naam || it.title));
      if (rows.length === 0) return 0;
      const tbody = document.createElement('tbody');
      rows.forEach((item, i) => {
        const tr = document.createElement('tr');
        tr.style.cssText = i % 2 === 0 ? 'background:white' : 'background:#f8fafc';
        tr.onmouseenter = () => tr.style.background = '#eff6ff';
        tr.onmouseleave = () => tr.style.background = i % 2 === 0 ? 'white' : '#f8fafc';
        const tdNr = document.createElement('td');
        tdNr.style.cssText = 'padding:8px 14px;border-bottom:1px solid #f1f5f9;color:#64748b;font-weight:500';
        tdNr.textContent = item.nr || item.nummer || (i + 1);
        const tdName = document.createElement('td');
        tdName.style.cssText = 'padding:8px 14px;border-bottom:1px solid #f1f5f9;color:#1e293b;font-weight:500';
        if (item.url) {
          const a = document.createElement('a');
          a.href = item.url;
          a.textContent = item.name || item.naam || item.title || '-';
          a.style.cssText = 'color:#0ea5e9;text-decoration:none;font-weight:600';
          a.onmouseenter = () => { a.style.textDecoration = 'underline'; };
          a.onmouseleave = () => { a.style.textDecoration = 'none'; };
          tdName.appendChild(a);
        } else {
          tdName.textContent = item.name || item.naam || item.title || '-';
        }
        const tdSku = document.createElement('td');
        tdSku.style.cssText = 'padding:8px 14px;border-bottom:1px solid #f1f5f9;color:#94a3b8;font-size:0.75rem;font-family:monospace';
        tdSku.textContent = item.sku || item.artikelnummer || item.article || '';
        tr.appendChild(tdNr);
        tr.appendChild(tdName);
        tr.appendChild(tdSku);
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      container.appendChild(table);
      return rows.length;
    }

    const fitsRaw = section.querySelector('[data-fits-json]')?.textContent;
    const fitsDesktopCount = renderFitsList(section.querySelector('[data-fits-list-scroll]'), fitsRaw);
    const fitsMobileCount = renderFitsList(section.querySelector('[data-fits-list-scroll-mobile]'), fitsRaw);
    /* Hide the tab/panel when the metafield holds no renderable device rows*/
    if (!fitsDesktopCount) {
      section.querySelector('[data-product-tab="compatibel"]')?.remove();
      section.querySelector('[data-product-panel="compatibel"]')?.remove();
    }
    if (!fitsMobileCount) {
      section.querySelector('[data-fits-list-scroll-mobile]')?.closest('details')?.remove();
    }

    /* Set 2-col grid when both diagram and list exist*/
    const partsGrid = section.querySelector('[data-parts-grid]');
    if (partsGrid && partsGrid.children.length === 2) {
      partsGrid.style.gridTemplateColumns = '1fr 1fr';
    }

    /* ─── Mobile PDF fallback removed ───*/
    /* Previously hid manual iframe on mobile, but Document & Onderdelen tabs*/
    /* show PDFs fine on mobile, so manual should too. Fallback divs remain in*/
    /* HTML as graceful degradation if a browser truly cannot render the iframe.*/

    /* ─── Mobile accordion (with lazy PDF loading) ───*/
    section.querySelectorAll('details[name="product-accordion"]').forEach(details => {
      let hasBeenToggled = false;
      details.querySelector('summary')?.addEventListener('click', () => {
        hasBeenToggled = true;
      });
      details.addEventListener('toggle', () => {
        if (details.open) {
          /* Lazy-load PDFs when accordion opens*/
          activateLazyPdfs(details);
          if (hasBeenToggled) {
            setTimeout(() => {
              const summary = details.querySelector('summary');
              if (summary) {
                const headerH = document.querySelector('[data-header]')?.offsetHeight || 72;
                const y = summary.getBoundingClientRect().top + window.scrollY - headerH - 12;
                window.scrollTo({ top: y, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
              }
            }, 50);
          }
        }
      });
    });
  });
